import { Component, OnInit } from '@angular/core';
import { HelpersService } from './services/helpers.service';

declare var require: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Smart campus backoffice';
  public version = require('package.json').version;
  constructor(private hS: HelpersService) {}
}
